<div #polarArea class="d-flex justify-content-center polar-chart" style="margin-bottom: -45px;"> </div>